import React,{useEffect,useState} from 'react';
import {connect} from "react-redux";
import store from 'src/store'
import {subscribeChannel, webSocketState} from "src/containers/websockets/SocketRouter";
import {updateAppSettings} from "src/actions/foundationActions";
import {resetWS} from "src/containers/websockets/TDPWS";


const WebSocketMonitor = (props) => {
    let stateData = store.getState();

    let restFunc = props["resetFunction"] ? props["resetFunction"] : ()=>resetWS();
    let subscribeFunction = props["subscribeFunction"] ? props["subscribeFunction"] : (channel)=> subscribeChannel( channel);
    let getSocketState = props["socketState"] ? props["socketState"] : ()=>webSocketState();

    let startedThisrender=false;
    let wsExists    = !!stateData.webSocketData.websocket;
    let wsstate = getSocketState();
    let clientid    = stateData.webSocketData.clientid;

    let roomid = stateData.gameTime.activeRoom ? stateData.gameTime.activeRoom.roomid : null;
    let roomSubscribed = stateData.webSocketData.subscriptions
        ? stateData.webSocketData.subscriptions.hasOwnProperty(roomid) && stateData.webSocketData.subscriptions[roomid].subscribed===1
        : false;

    let [trigger,setTrigger] = useState(0);

    useEffect(()=>{
        if(!wsExists && !startedThisrender) {
            restFunc();
            //eslint-disable-next-line
            startedThisrender=true;
        }
    },[wsExists]);

    useEffect(()=>{
        if(wsstate===3 && !startedThisrender){
            restFunc();
            //eslint-disable-next-line
            startedThisrender=true;
        }
        //eslint-disable-next-line
    },[wsstate]);


    useEffect(()=>{
        if((!clientid || clientid==="") && !startedThisrender){
            restFunc();
            //eslint-disable-next-line
            startedThisrender=true;
        }
        //eslint-disable-next-line
    },[clientid]);

    useEffect(()=>{
        if(wsExists && wsstate===1 && roomid && !roomSubscribed && !startedThisrender){
            subscribeFunction( `games.` + roomid);
            if(trigger <= 10) {
                setTimeout(() => setTrigger(trigger + 1), 10000);
            }
            else{
                store.dispatch(updateAppSettings({errorMessage:"it didn't work!"}))
            }
        }
        //eslint-disable-next-line
    },[
        wsExists,
        wsstate,
        roomid,
        roomSubscribed,
        trigger
    ]);

    return <span style={{display:"none"}} id={"webSocketMonitor"}>WSMonitor</span>};

const mapStateToProps = (state) =>{
    return {
        gameTime:state.gameTime,
        gameState:state.gameState,
        webSocketData:state.webSocketData,
    };
};

export default connect(mapStateToProps,{})(WebSocketMonitor);


